const constants = {
    authLoginRoute: "auth/login",
    authLogoutRoute: "auth/logout",
    jsonServerUsers: "/Users",
};

export default constants;

export const hashTag_p_boredom = "#p_boredom";
export const hashTag_thisweek = "#thisweek";

export const calendarEvent_freeTime = `free time`;